import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Notify } from 'notiflix/build/notiflix-notify-aio';
import { LoginModel } from 'src/app/nutrigenic/models/auth/login-model';
import { AuthService } from 'src/app/nutrigenic/services/auth/auth.service';
import { JwtTokenService } from 'src/app/nutrigenic/services/auth/jwt-token.service';
import { GoogleLoginProvider, SocialAuthService } from '@abacritt/angularx-social-login';
declare var AppleID: any;

@Component({
  selector: 'app-login-dialog',
  templateUrl: './login-dialog.component.html',
  styleUrls: ['./login-dialog.component.scss']
})
export class LoginDialogComponent {
  @Input() visible = false;
  @Input() isWebView = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() switchToSignup = new EventEmitter<void>();
  @Output() switchToForgotPassword = new EventEmitter<void>();

  loginModel: LoginModel = new LoginModel();

  constructor(
    private authService: AuthService,
    private jwtTokenService: JwtTokenService,
    private googleAuthService: SocialAuthService
  ) {}

  handleHide() {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  login() {
    this.authService.checkUserRegType({ email: this.loginModel.email }).subscribe((res: any) => {
      if (res.body.type == 2) {
        this.loginWithGoogle();
      } else if (res.body.type == 3) {
        this.loginWithApple();
      } else {
        this.authService.login(this.loginModel).subscribe({
          next: (response: any) => {
            const token = response.body.tokens.access_token;
            const userName = response.body.user.first_name + ' ' + response.body.user.last_name;
            const id = response.body.user.id;
            const email = response.body.user.email;
            const customer_id = response.body.user.customer_id ? response.body.user.customer_id : '';

            this.jwtTokenService.setToken(token);
            this.jwtTokenService.setUserName(userName, id, email, customer_id);
            if (response.body.user.managed_by_expert)
              this.jwtTokenService.setExpert(response.body.user.managed_by_expert.id);

            this.handleHide();
            window.location.reload();
          },
          error: () => {
            Notify.failure('Incorrect credentials', { position: 'right-top', timeout: 3000 });
          }
        });
      }
    });
  }

  loginWithGoogle() {
    this.googleAuthService.getAccessToken(GoogleLoginProvider.PROVIDER_ID)
      .then((res) => {
        this.authService.loginWithGoogle(res).subscribe({
          next: (response: any) => {
            const token = response.body.access_token;
            const userName = response.body.user.first_name + ' ' + response.body.user.last_name;
            const id = response.body.user.id;
            const email = response.body.user.email;
            const customer_id = response.body.user.customer_id ? response.body.user.customer_id : '';

            this.jwtTokenService.setToken(token);
            this.jwtTokenService.setUserName(userName, id, email, customer_id);
            if (response.body.user.managed_by_expert)
              this.jwtTokenService.setExpert(response.body.user.managed_by_expert.id);

            this.handleHide();
            window.location.reload();
          },
          error: () => {
            Notify.failure('User already registered', { position: 'right-top', timeout: 3000 });
          }
        });
      }).catch((error) => {
        console.log(error);
      });
  }

  async loginWithApple() {
    try {
      AppleID.auth.init({
        clientId: 'com.nutri.genic.client',
        scope: 'name email',
        redirectURI: 'https://nutrigenic.co.uk/',
        state: 'init',
        nonce: 'test',
        usePopup: true
      });
      const data = await AppleID.auth.signIn();
      this.authService.loginWithApple(data.authorization.id_token).subscribe({
        next: (response: any) => {
          const token = response.body.access_token;
          const userName = response.body.user.first_name + ' ' + response.body.user.last_name;
          const id = response.body.user.id;
          const email = response.body.user.email;
          const customer_id = response.body.user.customer_id ? response.body.user.customer_id : '';

          this.jwtTokenService.setToken(token);
          this.jwtTokenService.setUserName(userName, id, email, customer_id);
          if (response.body.user.managed_by_expert)
            this.jwtTokenService.setExpert(response.body.user.managed_by_expert.id);

          this.handleHide();
          window.location.reload();
        },
        error: () => {
          Notify.failure('User already registered', { position: 'right-top', timeout: 3000 });
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
}
